import * as React from "react";
function findPathParent(obj, arr) {
  if (!obj)
    return;
  arr.push(obj.type);
  const children = obj.props?.children;
  if (obj.type === "path" && !children) {
    return arr.pop();
  } else if (typeof children === "object") {
    if (Array.isArray(children)) {
      for (let i = 0; i < children.length; i++) {
        const result = findPathParent(children[i], arr);
        if (result) {
          break;
        }
      }
    } else {
      findPathParent(children, arr);
    }
  } else {
    arr.pop();
  }
}
function addNewStyle(newStyle) {
  let styleElement = document.getElementById("styles_js");
  if (!styleElement) {
    styleElement = document.createElement("style");
    styleElement.type = "text/css";
    styleElement.id = "styles_js";
    document.getElementsByTagName("head")[0].appendChild(styleElement);
  }
  styleElement.appendChild(document.createTextNode(newStyle));
}
function changePathStyle(props, arr, id) {
  if (!props)
    return;
  const str = arr.join(" ");
  const root = arr[0];
  const others = arr.slice(1);
  if (props.color) {
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(1) {fill: " + props.color + "}");
  }
  if (props["data-hovercolor"]) {
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-hovercolor"] + "}");
  }
  if (props["data-activecolor"]) {
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-activecolor"] + "}");
  }
  if (Array.isArray(props["data-twotonecolor"])) {
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-twotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-twotonecolor"][1] + "}");
  }
  if (Array.isArray(props["data-hovertwotonecolor"])) {
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-hovertwotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-hovertwotonecolor"][1] + "}");
  }
  if (Array.isArray(props["data-activetwotonecolor"])) {
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-activetwotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-activetwotonecolor"][1] + "}");
  }
  if (props.width) {
    addNewStyle(root + "#" + id + "{width: " + props.width + "}");
  }
  if (props.height) {
    addNewStyle(root + "#" + id + "{height: " + props.height + "}");
  }
}
const isArrayContainsElement = (arr1, arr2) => {
  for (let i = 0; i < arr2.length; i++) {
    if (arr1.includes(arr2[i])) {
      return true;
    }
  }
  return false;
};
const OPTIONS = ["color", "data-activecolor", "data-hovercolor", "data-twotonecolor", "data-hovertwotonecolor", "data-activetwotonecolor", "width", "height"];
const SvgEye = (props) => {
  const isSetOptions = isArrayContainsElement(Object.keys(props), OPTIONS);
  const svg = /* @__PURE__ */ React.createElement("svg", { width: 18, height: 14, viewBox: "0 0 18 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", id: "eye_svg_plugin_76286", ...props }, /* @__PURE__ */ React.createElement("g", { id: "Group 1" }, /* @__PURE__ */ React.createElement("g", { id: "Union" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.00006 3.93767C7.30869 3.93767 5.93756 5.3088 5.93756 7.00017C5.93756 8.69154 7.30869 10.0627 9.00006 10.0627C10.6914 10.0627 12.0626 8.69154 12.0626 7.00017C12.0626 5.3088 10.6914 3.93767 9.00006 3.93767ZM7.68756 7.00017C7.68756 6.2753 8.27519 5.68767 9.00006 5.68767C9.72494 5.68767 10.3126 6.2753 10.3126 7.00017C10.3126 7.72505 9.72494 8.31267 9.00006 8.31267C8.27519 8.31267 7.68756 7.72505 7.68756 7.00017Z", fill: "#E0E0E0" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.781 3.41113C11.6996 -0.0400403 6.30036 -0.040037 3.21896 3.41113L0.720614 6.20928C0.318348 6.65982 0.318349 7.34053 0.720614 7.79107L3.21896 10.5892C6.30036 14.0404 11.6996 14.0404 14.781 10.5892L17.2793 7.79107C17.6816 7.34053 17.6816 6.65982 17.2793 6.20928L14.781 3.41113ZM4.52435 4.57666C6.90995 1.90479 11.09 1.90478 13.4756 4.57666L15.6395 7.00017L13.4756 9.42369C11.09 12.0956 6.90995 12.0956 4.52435 9.42369L2.3605 7.00017L4.52435 4.57666Z", fill: "#E0E0E0" }))));
  if (isSetOptions) {
    const parents = [];
    findPathParent(svg, parents);
    const id = svg.props.id;
    changePathStyle(props, parents, id);
  }
  return svg;
};
export default SvgEye;
